import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

//i18n
import { withTranslation } from "react-i18next";

// users
import avatar2 from '../../../assets/images/users/avatar-2.jpg';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import withRouter from '../../Common/withRouter';
import { verify_admin } from '../../../store/actions';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            username: "CVSKL"
        };
        this.toggle = this.toggle.bind(this);
    }


    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    componentDidMount() {
        // this.props.verify_admin()
        const data = (this.props.verifyAdmin && this.props.verifyAdmin.user && this.props.verifyAdmin.user.data && this.props.verifyAdmin.user.data.profile && this.props.verifyAdmin.user.data.profile.name) || "";
        if (data) {
            this.setState({ username: data })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.verifyAdmin !== prevProps.verifyAdmin) {
            const data = this.props.verifyAdmin && this.props.verifyAdmin?.user?.data?.profile?.name;
            if (data) {
                this.setState({ username: data })
            }
        }

        // Now you can use the 'username' variable as needed.
    }

    render() {
        return (
            <React.Fragment>

                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block user-dropdown">
                    <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
                        <span className="d-xl-inline-block ms-1 text-transform">{this.state.username}<i className="ri-arrow-down-s-line"></i></span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        <Link to="/user-profile"><DropdownItem><i className="ri-user-line align-middle me-1"></i> {this.props.t('Profile')}</DropdownItem></Link>
                        <Link to="/logout"><DropdownItem className="text-danger border-top"><i className="ri-shut-down-line align-middle me-1 text-danger"></i> {this.props.t('Logout')}</DropdownItem></Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { verifyAdmin } = state.Login;
    return { verifyAdmin };
}

export default withTranslation()(withRouter(connect(mapStatetoProps, { verify_admin })(ProfileMenu)));
